import React, {useEffect, useState} from "react";
import {useSelector} from "../../../shared-services/redux-tiny";
import {t} from "../../../shared-services/translate";
import DialogPDP from "./DialogPDP";
import {FaInfoCircle} from "react-icons/fa";
import useProductPrice, {PriceSuperscript, parsePrice} from "../useProductPrice";
import useWindowTools from "../../../react-hooks/useWindowTools";
import topLayerState from "../../../shared-services/globalState/topLayerState";

const PriceInfoPDP = (props) => {
  const {product} = props;
  const {currentCart} = useSelector(state => state.cart);
  const {bottomNotification} = useSelector(state => state.topLayer);

  const {isMobile} = useWindowTools();
  const {setBottomNotification, emptyBottomNotification} = topLayerState();

  const {packagePrice, currency} = useProductPrice(product);

  const [shippingCostRange, setShippingRange] = useState(null);
  const [showShipCostDialog, setShowShipCostDialog] = useState(false);
  const [showWCDialog, setShowWCDialog] = useState(false);

  const handleNotification = (notificationName, options = null) => {
    if (bottomNotification?.name === notificationName) {
      emptyBottomNotification();
    } else {
      setBottomNotification({
        name: notificationName,
        options
      });
    }
  };

  const toggleWCShow = () => {
    const notificationName = "BottomWCExplanation";

    if (isMobile) handleNotification(notificationName);
    else setShowWCDialog(!showWCDialog);
  };

  const toggleShipCostShow = () => {
    const notificationName = "BottomShipCostInfo";

    const options = {
      zurichPrices: shippingCostRange?.zurich,
      nonZurichPrices: shippingCostRange?.nonZurich
    };

    if (isMobile) handleNotification(notificationName, options);
    else setShowShipCostDialog(!showShipCostDialog);
  };

  const {
    weight_control_billing: weightControlled
  } = product;

  useEffect(() => {
    if (currentCart) {
      const {
        current_shipping_cost_range: currentShippingCostRange,
        general_shipping_cost_range: generalShippingCostRange
      } = currentCart;

      // const range = currentShippingCostRange || generalShippingCostRange;
      const range = generalShippingCostRange;
      if (!range) return;

      const shippingRange = {
        zurich: `${parsePrice(range.zurich[0])} - ${parsePrice(range.zurich[1])}`,
        nonZurich: `${parsePrice(range.non_zurich[0])} - ${parsePrice(range.non_zurich[1])}`
      };

      setShippingRange(shippingRange);
    }
  }, [currentCart]);

  return <div
    className={`
      flex
      ${isMobile
        ? "gap-5 justify-content-space-around align-items-baseline background-color-dimmed"
        : "margin-top-20 flex-direction-column align-items-flex-end"}
      `}
    style={{padding: isMobile ? "5px 10px" : "10px"}}
  >
    {packagePrice &&
      <div className="small text-color-dimmed">
        {t("products.package_price_display")}
        <span className="font-weight-600"> {currency} {packagePrice}</span>
      </div>
    }

    {weightControlled && <div
      className={`
        position-relative
        ${isMobile
          ? ""
          : `flex
            flex-direction-column
            align-items-flex-end
            justify-content-space-between
            full-width
        `}
      `}
    >
      <InfoNote
        onClick={toggleWCShow}
        className={`
          font-weight-600
          cursor-pointer
          text-color-orange
          ${isMobile ? "align-items-center" : "justify-content-flex-end"}
        `}
        style={{width: isMobile ? "fit-content" : null}}
      >
        {t("weight_control.cut_by_hand_title")}
      </InfoNote>

      {!isMobile && <DialogPDP
        name="WCpopover"
        show={showWCDialog}
        onClose={() => setShowWCDialog(false)}
      >
        {t("products.weight_control.explanation_pdp")}
      </DialogPDP>}

      {!isMobile && <div className={`
        text-color-dimmed
        font-weight-600
        ${isMobile ? "text-smaller" : "text-small text-align-right"}
      `}>
        (
        {`${t("products.weight_control.max_surcharge_per")} ${product?.packaging}`}
        &nbsp;
        <PriceSuperscript
          price={product?.price * product?.weight_control_deviation}
          currency={true}
          className="font-weight-900"
        />
        )
      </div>}
    </div>}

    {shippingCostRange && <div
      className={`${isMobile
        ? null
        : `
        position-relative
        full-width
        flex
        justify-content-flex-end`
      }`}
    >
      <InfoNote
        onClick={toggleShipCostShow}
        className={`
          font-weight-600
          cursor-pointer
          text-color-dimmed
          ${isMobile ? "" : "justify-content-flex-end margin-top-10"}
        `}
        style={{width: "fit-content"}}
      >
        {t("plus_shipping_costs")}
      </InfoNote>

      {!isMobile && <DialogPDP
        name="shipCostPopover"
        show={showShipCostDialog}
        onClose={() => setShowShipCostDialog(false)}
      >
        {t(
          "cart.delivery_info.delivery_cost_range",
          {zurichPrices: shippingCostRange.zurich, nonZurichPrices: shippingCostRange.nonZurich})}
      </DialogPDP>}
    </div>
    }
  </div>;
};

export default PriceInfoPDP;

const InfoNote = (props) => {
  const {
    children,
    className = "",
    style,
    ...additionalProps
  } = props;

  return <div
    className={`flex gap-5 align-items-center ${className}`}
    style={style}
    {...additionalProps}
  >
    <FaInfoCircle className="flex-shrink-0"/>

    <span className="text-align-right">
      {children}
    </span>
  </div>;
};
